<template>
  <div v-title="$route.meta.title">

    <div class="page-heading"
         style="position:relative;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/task/table">任务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <template slot="header">米单任务列表</template>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%"
                ref="multipleTable">
        <el-table-column prop="taskid"
                         width="116px"
                         label="任务ID"
        >
          <template slot-scope="scope">
            TSK{{scope.row.taskid}}
          </template>
        </el-table-column>
        <el-table-column prop="title"
                         label="任务标题"
        >
          <template slot-scope="scope">
            <router-link :to="'/task/detail/'+scope.row.taskid">
              <span style="color: rgb(88, 157, 248)">{{scope.row.title}}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="type"
                         label="任务类型"
                         width="51px"
        >
          <template slot-scope="scope">
          <span v-for="item in options.allType"
                v-if="scope.row.type === item.value">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="assignnum"
                         label="完成人"
                         width="84px"
        >
          <template slot-scope="scope">
            <router-link :to="'/order/table?taskid='+scope.row.taskid"
                         style="text-decoration:none"
                         v-if="scope.row.assignnum">
              <span style="color:rgb(88,157,248);">{{scope.row.assignnum}}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column  prop="salary"
                         label="赏金"
                         width="65px"
        >
          <template slot-scope="scope">
            {{salaryValue(scope.row.salary)}}
          </template>
        </el-table-column>
        <el-table-column label="任务时间"
                         width="94px"
        >
          <template slot-scope="scope">
            {{scope.row.starttime}}<br/>{{scope.row.endtime}}
          </template>
        </el-table-column>
        <el-table-column label="城市"
                         width="162px"
        >
          <template slot-scope="scope">
            {{scope.row.provincename}}{{scope.row.cityname}}{{scope.row.areaname}}
          </template>
        </el-table-column>
        <el-table-column prop="marketname"
                         label="门店名称"
        >
          <template slot-scope="scope">
            <router-link :to="'/market/table?id='+scope.row.marketid"
                         target="_blank">
              {{scope.row.marketname}}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="status"
                         label="任务状态"
                         width="92px">
          <template slot-scope="scope">
            <span v-for="item in options.status"
                  v-if="scope.row.status === item.value">{{item.label}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="adminname"
                         label="任务发布人"
                         width="94px"
        ></el-table-column>
        <el-table-column prop="customer"
                         label="所属客户"
                         width="84px"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.customerid">{{scope.row.customer_name}}/{{scope.row.customer_number}}</span>
            <span v-if="!scope.row.customerid">平台</span>
          </template>
        </el-table-column>
        <el-table-column label="发布时间"
                         sortable="custom"
                         width="94px"
                         prop="publishtime"
        >
          <template slot-scope="scope">
            {{scope.row.publishtime}}<br/>
            {{scope.row.lastupdatetime}}
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="145"
        >
          <template slot-scope="scope">
            <TaskOperationButtons
              @publish="onPublishTask(scope.row)"
              :scope="scope"></TaskOperationButtons>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import taskMixins from '../task.mixins'
import OrderSearch from '../../order/components/OrderSearch'
import TaskBatchPublishButton from '../components/buttons/TaskBatchPublishButton'
import TaskBatchDeleteButton from '../components/buttons/TaskBatchDeleteButton'
import TaskPublishOnSearchButton from '@/views/task/components/buttons/TaskPublishOnSearchButton'
import TaskOperationButtons from '@/views/task/components/buttons/TaskOperationButtons'
import TaskDescButton from '../components/buttons/TaskDescButton'

export default {
  mixins: [table, taskMixins],
  components: {
    TaskBatchPublishButton,
    TaskBatchDeleteButton,
    TaskPublishOnSearchButton,
    TaskOperationButtons,
    OrderSearch,
    TaskDescButton
  },
  data () {
    return {
      table: [],
      type: 2,
      projectType: 0,
      multipleSelection: [],
      dialogVisible: false,
      dialogBatchVisible: false,
      search: {
        id: '',
        onlineRange: [],
        offlineRange: [],
        reformat: 1,
        start_begin: null,
        start_end: null,
        endtime_begin: null,
        endtime_end: null,
        customerid: null,
        projectid: null,
        type: null,
        batchid: null,
        status: null,
        templateid: null,
        userid: null,
        taskmarketareaid: null,
        marketname: null,
        locked: null,
        text: null,
        review_begin: null,
        review_end: null,
        sort_by_review: null,
        sort_by_lastupdatetime: null,
      },
      // 搜索字段申明
      searchFieldType: {
        type: Number,
        status: Number,
        locked: Number,
        review_begin: Number,
        review_end: Number,
        taskmarketareaid: Number,
      },
      exportAsync: false,
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.order.options,
    }),
    // 批量发布任务的项目成本检查, 必须保证要发布的任务是一个项目的
    isSearchProjectScope () {
      return this.lastSeachParams.projectid > 0 || this.lastSeachParams.batchid > 0
    }
  },
  created () {
  },
  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      params.id = this.$route.params.id
      return request.page('getMiDanTaskTable', params)
    },

    onExportPage (onlyBasic) {
      this.dialogVisible = false
      if (this.multipleSelection.length <= 0) {
        this.$message.error('请至少选择批量导出一个')
        return false
      }
      let multipleIds = {
        'taskid': this.multipleSelection.map(item => item.taskid),
        'only_basic': onlyBasic,
        'export_async': this.exportAsync,
      }
      if (this.exportAsync) {
        return this.onExportAsync(multipleIds)
      }
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, {
        fileHeader: this.exportHeader,
        total: multipleIds.taskid.length,
        request: (params) => request('exportTask', params),
        requestParams: multipleIds,
        fileType: 'csv',
        type: 'array',
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    onBatchExportSearch (onlyBasic) {
      this.dialogBatchVisible = false
      let detail = this.search
      detail.only_basic = onlyBasic
      detail.export_async = this.exportAsync

      if (this.exportAsync) {
        return this.onExportAsync(detail)
      }

      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, {
        fileHeader: this.exportHeader,
        total: this.pagination.length,
        request: (params) => request('exportTask', params),
        requestParams: detail,
        fileType: 'csv',
        type: 'array',
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    cleanMultipleSelection () {
      this.$refs.multipleTable.clearSelection()
      this.onSearch()
    },
    onExportAsync (detail) {
      if (detail.export_async) {
        request.common('exportTask', detail).then(() => {
          this.$message.success('创建成功，请在任务管理中心查看！')
        })
      }
    },
    showExportDialog () {
      this.dialogVisible = true
      this.exportAsync = false
    },
    showExportSearchDialog () {
      this.dialogBatchVisible = true
      this.exportAsync = false
    },
    salaryValue (value) {
      return filter.hasPermission(250) ? value : '*'
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
a {
  text-decoration: none;
}

.blue-color {
  color: rgb(88, 157, 248);
}

.el-dialog .el-checkbox {
  white-space: normal;
}

.el-dialog .el-checkbox /deep/ .el-checkbox__label {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/views/task/pages/MidanTaskTable.vue